/**
 * Hospital Indemnity Coverage Skeleton
 *
 * Provides default structure for a new Hospital Indemnity benefit plan.
 */

import {
  BaseBenefitPlanPolicyPeriod,
  RfpCoverage,
  CoverageTypeEnum,
  BenefitPlanTypeEnum,
  PlanOptionNameEnum,
  FundingTypeEnum,
  RfpBenefitPlan,
} from "../../types/rfp.api.types";

export const getHospitalIndemnitySkeleton = (): Partial<RfpCoverage> => ({
  type: CoverageTypeEnum.HOSPITAL_INDEMNITY,
  status: "quoted",
  notes: "",
  benefitPlans: [
    {
      identifier: "hospitalIndemnity-plan-1",
      name: "Hospital Indemnity Plan",
      numberOfLives: 0,
      type: BenefitPlanTypeEnum.NOT_APPLICABLE,
      policyPeriod: BaseBenefitPlanPolicyPeriod.newBusiness,
      fundingType: FundingTypeEnum.FULLY_INSURED,
      participationRequirements: "",
      rateGuarantee: undefined,
      rateCap: "",
      optionName: PlanOptionNameEnum.NOT_APPLICABLE,
      benefitClassAvailability: [],
      rateSchedule: [],
      benefits: {
        objectType: "hospitalIndemnity",
        employerContribution: undefined,
        hospitalAdmissionType: "notIncluded",
        hospitalAdmissionAmount: 0,
        icuAdmissionType: "notIncluded",
        icuAdmissionAmount: 0,
        hospitalConfinementType: "notIncluded",
        hospitalConfinementAmount: 0,
        icuConfinementType: "notIncluded",
        icuConfinementAmount: 0,
        wellnessType: "notIncluded",
        wellnessAmount: 0,
        preExistingConditionType: "none",
        preExistingConditionMonthsDiagnosisFreeBeforeEffDate: 0,
        preExistingConditionMonthsTreatmentFree: 0,
        preExistingConditionMonthsDiagnosisFreeAfterEffDate: 0,
        portability: undefined,
        annualOpenEnrollment: undefined,

        // Extended (non-v5) fields — CD-1943/CD-2076
        eligibility: undefined,
        twentyFourHourCoverage: undefined,
        pregnancy: undefined,
        newbornNurseryCare: undefined,
        eligibilityHours: undefined,
        pregnancyWaitingPeriodNote: undefined,
      },
    } as RfpBenefitPlan,
  ],
});
